import BartenderOne from '../../../../../img/bartender.jpg';
import '../Hero/hero.style.css';

function HeroHome() {
    return (
        <section className="HeroHome">
            <div className="HeroHome-Container-carrousel">
                <div style={{ backgroundImage: `url(${BartenderOne})` }} className="Carrousel-one">
                    <div className='Carrousel-one-item'>
                        <h3><span>B & M</span> V.I.P</h3>
                        <div className='Paragraph-HeroHome'>
                        <p>
                            Encuentra la mejor calidad en servicios como: Bartenders y Meseros en planeación de eventos; personal calificado y capacitado con normatividad de sanidad vigente.
                        </p>
                        </div>
                        <button>Reservar</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroHome;